<div class="stepper-wrapper">
  @if (swShowOnlyOrderBreakdown) {
  <p-stepper [value]="stepPanel.PanelOne" class="basis-[50rem]">
    <p-step-list>
      <p-step [value]="stepPanel.PanelOne" [disabled]="true">Cotización</p-step>
      <p-step [value]="stepPanel.PanelTwo" [disabled]="true">Despiece</p-step>
    </p-step-list>
    <p-step-panels>
      <p-step-panel [value]="1">
        <ng-template #content let-activateCallback="activateCallback">
          <div class="container-style">
            @if (loading) {
            <div class="p-4">
              <p-skeleton styleClass="custom-skeleton-header"></p-skeleton>
              <p-skeleton styleClass="custom-skeleton-body"></p-skeleton>
            </div>
            } @else {
            <app-custom-table [showRecover]="true" [radioButton]="true" [showCheckbox]="true" [isMultipleSelect]="false"
              [data]="dataQuotation" [headers]="quotationHeader" [previousFilters]="filtersQuotation"
              [rowClass]="quotationRowClass"
              (onRecoverData)="getQuotationsForSelection()" (selectionChange)="selectionChange($event)"
              (onPageChange)="onPageChange($event)" (onFilterChange)="onFilterChange($event)">
            </app-custom-table>
            }
          </div>
          <div class="step-footer mt-2">
            <div></div>
            <small class="text-secondary text-center">
              <i class="pi pi-check-circle text-success"></i>
              {{ quotationLegend }}
            </small>
            <div class="d-flex justify-content-end">
              <app-custom-button [width]="'6.5'" [severity]="'contrast'" [label]="'Siguiente'"
                [icon]="'pi pi-arrow-right'" (onClick)="goToStep(stepPanel.PanelTwo, activateCallback)">
              </app-custom-button>
            </div>
          </div>
        </ng-template>
      </p-step-panel>
      <p-step-panel [value]="stepPanel.PanelTwo">
        <ng-template #content let-activateCallback="activateCallback">
          <div class="container-style">
            <app-custom-table [showRecover]="true" [showCheckbox]="true" [isMultipleSelect]="true"
              [data]="dataBreakdown" [headers]="breakdownHeader" [checkBoxAction]="checkboxActions"
              [rowClass]="breakdownRowClass"
              [previousFilters]="filtersBreakdown" (onPageChange)="onPageChange($event)" (onAction)="onAction($event)"
              (onRecoverData)="getBreakdownForSelection()" (onFilterChange)="onFilterChange($event)">
            </app-custom-table>
          </div>
          <div class="step-footer mt-2">
            <div>
              <app-custom-button [width]="'6.5'" [label]="'Regresar'" [severity]="'contrast'" [icon]="'pi pi-arrow-left'"
                (onClick)="goToStep(stepPanel.PanelOne, activateCallback)">
              </app-custom-button>
            </div>
            @if (orderModel.orderId !== 0) {
            <small class="text-secondary text-center">
              <i class="pi pi-check-circle text-success"></i>
              Los artículos resaltados son de soluciones del mismo centro de costos del pedido.
            </small>
            } @else {
            <small class="text-secondary text-center">
              <i class="pi pi-info-circle"></i>
              Seleccione artículos de soluciones de un mismo centro de costos.
            </small>
            }
            <div></div>
          </div>
        </ng-template>
      </p-step-panel>
    </p-step-panels>
  </p-stepper>
  } @else {
  <p-stepper [value]="stepPanel.PanelOne" class="basis-[50rem]">
    <p-step-list>
      <p-step [value]="stepPanel.PanelOne" [disabled]="true">Cotización</p-step>
      <p-step [value]="stepPanel.PanelTwo" [disabled]="true">Solución</p-step>
      <p-step [value]="stepPanel.PanelThree" [disabled]="true">Despiece</p-step>
    </p-step-list>
    <p-step-panels>
      <p-step-panel [value]="stepPanel.PanelOne">
        <ng-template #content let-activateCallback="activateCallback">
          <div class="container-style">
            @if (loading) {
            <div class="p-4">
              <p-skeleton styleClass="custom-skeleton-header"></p-skeleton>
              <p-skeleton styleClass="custom-skeleton-body"></p-skeleton>
            </div>
            } @else {
            <app-custom-table [showRecover]="true" [radioButton]="true" [showCheckbox]="true" [isMultipleSelect]="false"
              [data]="dataQuotation" [headers]="quotationHeader" [previousFilters]="filtersQuotation"
              [rowClass]="quotationRowClass"
              (onRecoverData)="getQuotationsForSelection()" (selectionChange)="selectionChange($event)"
              (onPageChange)="onPageChange($event)" (onFilterChange)="onFilterChange($event)">
            </app-custom-table>
            }
          </div>
          <div class="step-footer mt-2">
            <div></div>
            <small class="text-secondary text-center">
              <i class="pi pi-check-circle text-success"></i>
              {{ quotationLegend }}
            </small>
            <div class="d-flex justify-content-end">
              <app-custom-button [width]="'6.5'" [severity]="'contrast'" [label]="'Siguiente'"
                [icon]="'pi pi-arrow-right'" (onClick)="goToStep(stepPanel.PanelTwo, activateCallback)">
              </app-custom-button>
            </div>
          </div>
        </ng-template>
      </p-step-panel>
      <p-step-panel [value]="stepPanel.PanelTwo">
        <ng-template #content let-activateCallback="activateCallback">
          <div class="container-style">
            <app-custom-table [showRecover]="true" [radioButton]="true" [showCheckbox]="true" [isMultipleSelect]="false"
              [data]="dataQuotationDetail" [headers]="quotationDetailHeader" [previousFilters]="filtersQuotationDetail"
              [rowClass]="solutionRowClass"
              (onRecoverData)="getQuotationsForSelection()" (selectionChange)="selectionChange($event)"
              (onPageChange)="onPageChange($event)" (onFilterChange)="onFilterChange($event)">
            </app-custom-table>
          </div>
          <div class="step-footer mt-2">
            <div>
              <app-custom-button [width]="'6.5'" [label]="'Regresar'" [severity]="'contrast'"
                [icon]="'pi pi-arrow-left'" (onClick)="goToStep(stepPanel.PanelOne, activateCallback)">
              </app-custom-button>
            </div>
            @if (swSolutionCostCenterRule) {
            <small class="text-secondary text-center">
              <i class="pi pi-check-circle text-success"></i>
              Las soluciones resaltadas son del mismo centro de costos del pedido.
            </small>
            } @else {
            <small class="text-secondary text-center">
              <i class="pi pi-info-circle"></i>
              Puede seleccionar una solución de cualquier centro de costos.
            </small>
            }
            <div class="d-flex justify-content-end">
              <app-custom-button [width]="'6.5'" [label]="'Siguiente'" [severity]="'contrast'"
                [icon]="'pi pi-arrow-right'" (onClick)="goToStep(stepPanel.PanelThree, activateCallback)">
              </app-custom-button>
            </div>
          </div>
        </ng-template>
      </p-step-panel>
      <p-step-panel [value]="stepPanel.PanelThree">
        <ng-template #content let-activateCallback="activateCallback">
          <div class="container-style">
            <app-custom-table [showRecover]="true" [showCheckbox]="true" [isMultipleSelect]="true"
              [data]="dataBreakdown" [headers]="breakdownHeader" [checkBoxAction]="checkboxActions"
              [previousFilters]="filtersBreakdown" (onPageChange)="onPageChange($event)" (onAction)="onAction($event)"
              (onRecoverData)="getBreakdownForSelection()" (onFilterChange)="onFilterChange($event)">
            </app-custom-table>
          </div>
          <div class="d-flex mt-2 justify-content-start">
            <app-custom-button [width]="'6.5'" [label]="'Regresar'" [severity]="'contrast'" [icon]="'pi pi-arrow-left'"
              (onClick)="goToStep(stepPanel.PanelTwo, activateCallback)">
            </app-custom-button>
          </div>
        </ng-template>
      </p-step-panel>
    </p-step-panels>
  </p-stepper>
  }
</div>